import type { Theme } from './types'

export const themeLocalStorageKey = 'payload-theme'

/** Site-wide default — dark is forced across the frontend. */
export const defaultTheme: Theme = 'dark'

export const getImplicitPreference = (): Theme | null => {
  // OS preference is ignored; the site always uses dark.
  return defaultTheme
}
